module.exports = __webpack_public_path__ + "img/dokanandroid-250.01f80fdb.jpg";